import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Messages } from 'src/app/core/messages/messages';
import { DialogRef, DialogContentBase } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-header-alert-modal',
  templateUrl: './header-alert-modal.component.html',
  styleUrls: ['./header-alert-modal.component.scss']
})
export class HeaderAlertModalComponent extends DialogContentBase implements OnInit {

  @Input() headerTitle: string;
  @Input() public message: string;
  @Input() buttonTitle: string;


  constructor(public dialog: DialogRef) {
    super(dialog);
  }

  /**
   * Descp: Function called on page init.
   */
  ngOnInit() {
    if (!this.headerTitle) {
    this.headerTitle = Messages.Dialog_Title;
   }
    if (! this.buttonTitle) {
    this.buttonTitle = Messages.Dialog_Button_Ok;

   }

  }

  public onConfirmAction() {
    this.dialog.close({ primary: true, data: true });
  }

}
